export interface Name {
  readonly firstName: string;
  readonly lastName: string;
}

export const fullName = (name: Name): string => {
  return `${name.firstName} ${name.lastName}`;
};

export const isValidFirstName = (firstName: string): boolean => {
  return !!firstName && firstName.toLowerCase() !== 'visitor';
};

export const isValidLastName = (lastName: string): boolean => {
  return !!lastName && !new RegExp(/#\d+$/).test(lastName);
};

export const listOfBoyFirstNames = [
  'John',
  'James',
  'Robert',
  'Michael',
  'William',
  'David',
  'Richard',
  'Joseph',
  'Charles',
  'Thomas',
  'Christopher',
  'Daniel',
  'Matthew',
  'Anthony',
  'Mark',
  'Donald',
  'Steven',
  'Paul',
  'Andrew',
  'Joshua',
  'Kenneth',
  'Kevin',
  'Brian',
  'George',
  'Edward',
  'Ronald',
  'Timothy',
  'Jason',
  'Jeffrey',
  'Ryan',
  'Jacob',
  'Gary',
  'Nicholas',
  'Eric',
  'Jonathan',
  'Stephen',
  'Larry',
  'Justin',
  'Scott',
  'Brandon',
  'Benjamin',
  'Samuel',
  'Gregory',
  'Frank',
  'Alexander',
  'Raymond',
  'Patrick',
  'Jack',
  'Dennis',
  'Jerry',
];

export const listOfGirlFirstNames = [
  'Mary',
  'Patricia',
  'Jennifer',
  'Linda',
  'Elizabeth',
  'Barbara',
  'Susan',
  'Jessica',
  'Sarah',
  'Karen',
  'Nancy',
  'Lisa',
  'Betty',
  'Dorothy',
  'Sandra',
  'Ashley',
  'Kimberly',
  'Donna',
  'Emily',
  'Michelle',
  'Carol',
  'Amanda',
  'Melissa',
  'Deborah',
  'Stephanie',
  'Rebecca',
  'Laura',
  'Sharon',
  'Cynthia',
  'Kathleen',
  'Amy',
  'Shirley',
  'Angela',
  'Helen',
  'Anna',
  'Brenda',
  'Pamela',
  'Nicole',
  'Ruth',
  'Katherine',
  'Samantha',
  'Christine',
  'Emma',
  'Catherine',
  'Debra',
  'Virginia',
  'Rachel',
  'Carolyn',
  'Janet',
  'Maria',
];
